import { render } from "./MenuItems.vue?vue&type=template&id=22797d70&scoped=true"
import script from "./MenuItems.vue?vue&type=script&lang=js"
export * from "./MenuItems.vue?vue&type=script&lang=js"

import "./MenuItems.vue?vue&type=style&index=0&id=22797d70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22797d70"]])

export default __exports__